import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import SacredFlame from "@/pages/SacredFlame";
import AssessmentHub from "@/pages/AssessmentHub";
import Assessment from "@/pages/Assessment";
import Consultation from "@/pages/Consultation";
import Book from "@/pages/Book";
import ClientExperiences from "@/pages/ClientExperiences";
import FAQ from "@/pages/FAQ";
import VideoSeries from "@/pages/VideoSeries";
import MemberArea from "@/pages/MemberArea";
import AssessmentResult from "@/pages/AssessmentResult";
import Zoom from "@/pages/Zoom";
import Privacy from "@/pages/Privacy";
import Disclaimer from "@/pages/Disclaimer";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/sacred-flame" element={<SacredFlame />} />
            <Route path="/assessments" element={<AssessmentHub />} />
            <Route path="/assessments/:id" element={<Assessment />} />
            <Route path="/results/:submissionId" element={<AssessmentResult />} />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/book" element={<Book />} />
            <Route path="/free-guide" element={<Book />} />
            <Route path="/sacred-flame-guide" element={<Book />} />
            <Route path="/experiences" element={<ClientExperiences />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/video-series" element={<VideoSeries />} />
            <Route path="/members" element={<MemberArea />} />
            <Route path="/zoom" element={<Zoom />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
